import { FormControl, Select, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';

import { GetPaymentMethods } from 'utils/payment';
import { useMjrApiUser } from 'utils/swrCalls';

const CardSelector = (props) => {
  const { cardSelected, HandleCardSelect } = props;
  const { data: user } = useMjrApiUser();
  const [paymentProfile, setPaymentProfile] = useState({});
  const [paymentLoading, setPaymentLoading] = useState(false);
  const { authNetCustomerProfileId } = user;

  const PaymentOption = (props) => {
    const { profile, index } = props;
    const card = profile.payment.creditCard;
    return <option value={index}>{`Card Ending in ${card.cardNumber}`}</option>;
  };

  useEffect(() => {
    GetPaymentMethods(authNetCustomerProfileId, setPaymentLoading, setPaymentProfile);
  }, []);

  const HandleSetCard = (event) => {
    HandleCardSelect(event.target.value, paymentProfile?.paymentProfiles[event.target.value], authNetCustomerProfileId);
  };

  return (
    <div className='payment-methods'>
      <Typography variant='body1'>{'Saved Payment Methods'}</Typography>
      <FormControl variant='outlined' className='card-select' disabled={!paymentProfile?.paymentProfiles?.length}>
        <Select
          native
          fullWidth
          value={cardSelected}
          onChange={HandleSetCard}
          labelWidth={105}
          required
          inputProps={{
            name: 'cardSelected',
          }}
        >
          <option value='' disabled>
            {paymentLoading === null ? 'Loading...' : (paymentProfile?.paymentProfiles?.length ? 'Select Card' : 'No saved payment methods available') }
          </option>
          {!paymentLoading
            && paymentProfile?.paymentProfiles
            && paymentProfile?.paymentProfiles.map((profile, index) => (
              <PaymentOption key={profile.customerPaymentProfileId} profile={profile} index={index} />
            ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default CardSelector;
